<template>
  <div>
    <v-navigation-drawer temporary v-model="drawer" fixed class="pt-5">
      <v-list dense expand class="mt-2">
          <template v-for="(item, i) in menus">
              <template v-if="item.roles.indexOf('*') !== -1 || item.roles.indexOf(userRole) !== -1 && isMenuActive(item) && isAgencyFeatureEnabled(item) && isChildManagementEnabled(item) && isCampaignAllowed(item)/* && (!session.getSession().adminUser || (session.getSession().adminUser && item.title !== 'Messages')) */">
                <v-list-group
                  :prepend-icon="item.icon"
                  no-action
                  v-if="item.children && item.children.length"
                  :key="i"
                >
                  <template v-slot:activator>
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title :class="{ 'menuTitleActive': $route.meta.navLink === item.name }" class="pf-menu-text">{{ item.title }}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>

                  <template v-for="(child, j) in item.children">
                    <v-list-tile
                      v-if="(child.roles.indexOf('*') !== -1 || child.roles.indexOf(userRole) !== -1) && isAgencyFeatureEnabled(child) && isChildManagementEnabled(child)"
                      :to="!child.href ? { name: child.name } : null" ripple="ripple" :disabled="child.disabled" :target="child.target" rel="noopener" :key="j" class="drawerItem" :class="{ 'menuActive': $route.meta.navLink === child.name }"
                    >
                      <v-list-tile-action v-if="child.icon">
                        <v-icon :class="{ 'menuTitleActive': $route.meta.navLink === child.name }">{{ child.icon }}</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title :class="{ 'menuTitleActive': $route.meta.navLink === child.name }" class="pf-menu-text">{{ child.title }}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>
                </v-list-group>
                <v-list-tile v-else :to="!item.href ? { name: item.name } : null" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="i" class="drawerItem" :class="{ 'menuActive': $route.meta.navLink === item.name }">
                  <v-list-tile-action v-if="item.icon">
                    <v-icon :class="{ 'menuTitleActive': $route.meta.navLink === item.name }">{{ item.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title :class="{ 'menuTitleActive': $route.meta.navLink === item.name }" class="pf-menu-text">{{ item.title }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
          </template>
        </v-list>
    </v-navigation-drawer>
  </div>
</template>
<script>
/* global session store */
import menu from '@/api/menu';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { getCollection } from '../helpers/helpers';
import is from 'is_js';
// Disabled Menu Items for ChildManagement
const childDisabledMenuItems = [
  'AdminBadgeContacts',
  'AgencyBadgeContacts',
  'AgencyActivity',
  'Messages',
  'ProfileLayoutSettings',
  'PaymentTransactions',
  'BMCampaignsAgency',
  'FamilyBadgeManagement',
  'APISettings',
  'Memberships',
  'Youtube',
  'SignupForm',
  'FamilyMenu',
  'FamilyContent',
  'BlogSettings',
  'ProfileDocumentsAgencyList',
  'Videos',
  'EditRequests'
];
// This is the app menu for the small view ports
export default {
  name: 'app-drawer-mini',
  components: {
    VuePerfectScrollbar,
  },
  props: {
    force: {
      default: false
    }
  },
  data: () => ({
    session: session,
    mini: false,
    drawer: false,
    menus: menu,
    status: is.online() ? 'online' : 'offline',
    menuEntity: 'Account',
    agencyConditionalFeatures: ['ChildManagement', 'FamilyManagement'],
    agencyFeatures: {
      'ChildBadgeManagement': 'ChildManagement',
      'FamilyBadgeManagement': 'FamilyManagement'
    },
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    userRole () {
      if (session.isOnline()) {
        return session.getSession().user.role;
      }
    },
    Account: {
      get () {
        return store.state.Account;
      },
      set (value) {
        store.commit('setAccount', value);
      }
    },
    Agency: {
      get () {
        return store.state.Agency;
      },
      set (value) {
        store.commit('setAgency', value);
      }
    },
    Child: {
      get () {
        return store.state.Child;
      },
      set (value) {
        store.commit('setChild', value);
      }
    },
    MenuSettings: {
      get () {
        return store.state.MenuSettings;
      },
      set (value) {
        store.commit('setMenuSettings', value);
      },
    }
  },
  watch: {
  },
  created () {
    this.menuEntity = session.role() === 'child' ? 'Child' : this.menuEntity;
    window.getApp.$on('APP_DRAWER_TOGGLED', () => {
      if (this.$vuetify.breakpoint.mdAndDown || this.force) {
        this.drawer = !this.drawer;
      }
    });
  },
  methods: {
    isMenuActive (menuItem) {
      if (menuItem && menuItem.name) {
        let menuIndex = null;
        let menuStatus = null;
        if (this.MenuSettings && this.MenuSettings.menu_settings && this.MenuSettings.menu_settings.length) {
          menuIndex = this.MenuSettings.menu_settings.findIndex(x => x.name === menuItem.name);
          if (menuIndex > -1) {
            menuStatus = this.MenuSettings.menu_settings[menuIndex].status;
            if (menuStatus === 'on') {
              return true;
            } else if (menuStatus === 'off') {
              return false;
            } else if (menuStatus === 'on_until_live') {
              return !(this[this.menuEntity].agency && this[this.menuEntity].agency.length && this[this.menuEntity].agency.filter(y => y.status === 'Active').length);
            }
          }
        }
      }
      return true;
    },
    isAgencyFeatureEnabled (menuItem) {
      if (session.role() !== 'agency') {
        return true;
      }
      if (menuItem && menuItem.name) {
        let index = this.agencyFeatures[menuItem.name] ? this.agencyFeatures[menuItem.name] : menuItem.name;
        if (this.Agency && this.agencyConditionalFeatures.indexOf(index) > -1 && this.Agency.feature_settings && this.Agency && this.Agency.feature_settings.length) {
          if (this.Agency.feature_settings.indexOf(index) > -1) {
            return true;
          }
          return false;
        } else if (index === 'ChildManagement') {
          return false;
        }
      }
      return true;
    },
    isChildManagementEnabled (menuItem) {
      if (this.Agency.feature_settings && menuItem && menuItem.name) {
        let index = menuItem.name;
        if (this.Agency && this.Agency.feature_settings && this.Agency.feature_settings.length) {
          if (this.Agency.feature_settings[0] === 'ChildManagement' && childDisabledMenuItems.indexOf(index) > -1) {
            return false;
          }
        }    
      }
      return true;
    },
    isCampaignAllowed (menuItem) {
      return !(this.Account && this.Account.google_campaign && this.Account.google_campaign.type === 'agency' && menuItem && menuItem.name && menuItem.name === 'BMCampaign');
    }
  }
};
</script>


<style scoped>

  .drawerItem.menuActive {
    background: #019d8c !important;
  }
  .menuTitleActive {
    color: #fff !important;
  } 
  .drawerItem.menuActive:hover {
    background: #019d8c !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/AppDrawerMini.vue